const palette = [
  // 1st row
  { color: "#FF5733", label: "Vibrant Red" },
  { color: "#33FF57", label: "Bright Green" },
  { color: "#3357FF", label: "Bright Blue" },
  { color: "#F1C40F", label: "Sunflower Yellow" },
  { color: "#9B59B6", label: "Amethyst Purple" },
  { color: "#E74C3C", label: "Alizarin Crimson" },
  { color: "#1ABC9C", label: "Turquoise" },
  { color: "#2ECC71", label: "Emerald Green" },
  // 2nd row
  { color: "#3498DB", label: "Light Blue" },
  { color: "#E67E22", label: "Carrot Orange" },
  { color: "#8E44AD", label: "Wisteria Purple" },
  { color: "#2980B9", label: "Belize Hole Blue" },
  { color: "#27AE60", label: "Green Sea" },
  { color: "#16A085", label: "Green" },
  { color: "#2C3E50", label: "Midnight Blue" },
  { color: "#D35400", label: "Pumpkin Orange" },
  // 3rd row
  { color: "#C0392B", label: "Pomegranate Red" },
  { color: "#BDC3C7", label: "Silver" },
  { color: "#7F8C8D", label: "Asbestos Gray" },
  { color: "#FF33A8", label: "Hot Pink" },
  { color: "#33FFA5", label: "Mint Green" },
  { color: "#A833FF", label: "Electric Purple" },
  { color: "#FFBD33", label: "Goldenrod" },
  { color: "#FF4500", label: "Orange Red" },
  // 4th row
  { color: "#3333FF", label: "Royal Blue" },
  { color: "#33FFD7", label: "Aqua" },
  { color: "#FF33FB", label: "Magenta" },
  { color: "#33FFB2", label: "Spring Green" },
  { color: "#FF9233", label: "Burnt Orange" },
  { color: "#6F42C1", label: "Purple" },
  { color: "#DAF7A6", label: "Pale Green" },
  { color: "#FFC300", label: "Yellow" }
];
export {
  palette
};
//# sourceMappingURL=palette.js.map
